import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ReadingTextList from '../components/ReadingTextList';
import ReadingTextEdit from '../components/ReadingTextEdit';

type IProps = {
  readingTextId: number;
};

const ReadingText: React.FC<IProps> = ({ readingTextId }) => {
  const [editText, setEditText] = useState(readingTextId);

  // Load text when navigated from external source
  useEffect(() => {
    setEditText(readingTextId);
  }, [readingTextId]);

  const onEditText = (textId: number) => {
    setEditText(textId);
  };

  return (
    <Container>
      <ReadingTextList onEditText={onEditText} editingTextId={editText} />
      <ReadingTextEdit readingTextId={editText} key={editText} />
    </Container>
  );
};

export default ReadingText;

const Container = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;
